const getMarketoInstance = () => window.Munchkin

export default getMarketoInstance
